<template>
    <div class="drawerLayer" v-show="visible">
        <div class="mask" @click="close();"></div>
        <div class="bottomDrawer white_bg">
            <div class="generalPagePaddingH">
                <header class="header paddingV16 bottomBorderFAFAFA">
                    <div class="flexLayout">
                        <div style="width: 16px;"></div>
                        <div class="flexItem alignCenter grey10 fWeight600">

                            <template v-if="body.type === 'requestSuccess'">收入修改</template>
                            <template v-else>{{title}}</template>

                        </div>
                        <div style="width: 16px;">
                            <i class="icon closeIcon" @click="close()"></i>
                        </div>
                    </div>
                </header>
                <div class="body" style="margin-top: 10px; padding-bottom: 34px;">

                    <template v-if="body.type === 'view'">
                        <div class="alignC paddingT12" style="line-height: 27px;">
                            售价：￥{{currentDataItem ? currentDataItem.price : ''}}<br/>
                            收入：<span class="orange">￥{{currentDataItem ? currentDataItem.totalIncome : ''}}</span>
                        </div>
                        <div style="padding: 0 40px; margin-top: 40px;">
                            <button class="updateButton block" @click="body.type = 'editing'">修改</button>
                            <button class="cancelButton block marginT20" @click="hide()">取消</button>
                        </div>
                    </template>

                    <template v-if="body.type === 'editing'">
                        <div class="paddingT12" style="line-height: 27px;">
                            售价：￥{{currentDataItem ? currentDataItem.price : ''}}<br/>
                            收入：￥
                            <input type="text" style="width: 80px;" v-model="newIncome"/>
                        </div>
                        <div style="padding: 0 40px; margin-top: 40px;">
                            <button class="updateButton block" @click="updateIncome()">确认修改</button>
                            <button class="cancelButton block marginT20" @click="body.type = 'view'">取消</button>
                        </div>
                    </template>

                    <template v-if="body.type === 'requestSuccess'">
                        <p class="orange" style="margin: 20px 0; line-height: 27px;">
                            您的课程收入修改已提交申请，待审核通过后生效，未通过则按之前的比例计算！
                        </p>
                        <div style="padding: 0 40px; margin-top: 40px;">
                            <button class="cancelButton block marginT20" @click="body.type = 'view'; close()">关闭</button>
                        </div>
                    </template>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import drawerPart from '../part/drawerPart';

import vodCourseApi from "@comp/vodCourse/vodCourseApi";

//
import appHelper from "@util/appHelper";

const config = {
    name: "viewInComeDrawer",
    apiConfig : {
        list : {
            url : "",
            dataPath : 'data.records',
            totalPagePath : 'data.pages',
            dataColumnMapping : {
                // userName : 'name''
            }
        },
        update : {
            url : ''
        }
    }
};

export default {
    name : config.name,
    extends : drawerPart,
    props : {
        title : {
            type : String,
            default : '查看收入'
        },
        currentDataItem : Object
    },
    data() {
        return {
            apiConfig : config.apiConfig,

            body : {

                // view | editing | requestSuccess
                type : 'view',
            },

            newIncome : ''
        }
    },
    methods : {
        updateIncome() {
            if (this.newIncome === '')
            {
                appHelper.showHint('请填写新的收入数据。');
                return;
            }

            vodCourseApi.subProportion({
                id : this.currentDataItem.vodId,
                // proportion : this.newIncome / this.currentDataItem.price
                proportion : this.newIncome
            }, () => {
                this.body.type = 'requestSuccess';
            });
        }
    }
}
</script>

<style lang="scss" scoped>
.header {
    .closeIcon {
        width: 14px;
        height: 14px;
        background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAACFklEQVRoge2ZQU/bMBhALWCdhPgZvfnk7305k/MkdhgwumqI/vkxpE2CaTsgtaG7xCjqbEiKnWRSntRDqzp+L0nbNDZmYmIiCHBsrT0Z2sNaewIcdxqkqh+AP8CjiHzO5PYqIvIJeAR+q2rZdtwhcAts68daVc8zegZR1Qtg3fC4NcYcvDoQeAc8NAb6iIv82s8OlzvyW+DeGHPYdgNLEakCEdmPRGDPb4EnEbnqtCERWfUdISJXEfnVvhsMRgCXadWf5TfJ5BsbDkVsnHNf0qhnlG9MkC0iu3xjouQRIfl6jpuU7s0Jk0XE5FX1Ood7c+I3Rwwm3xDYO8I5txhU3rNPBLAEqsHlPV0iRifvaRMxWnnPSxEheWA88p5YROC1ClgO7RtERL4GflX/D3lPfdr8E1EfiXHLG2OMql4HTpvkF4BZeEF+/BEh+fr57uk0vojInq+AZeQzMZ6IiPzGObfw74lFJL/m70pMPvQHPBQhItVgEV3kPaOJAG66ynsGjxCRFfC0j7xnsIgU8p7eI1LKe3qLiMiv3yLvyR4Rk095szdbRB/ynuQRfcp7kkWo6qJveQ+BtYE6ot1KkbV2BvzalSfDHekYkTWCe2vtrM34A+B786uyz9UZj6qe70R8M22WmIwxpiiKU+AO+CEiZ3lV4zjnPgI/gbuiKE47DS7L8mg+n7/P5NYaa+2sLMujoT0mJsbKX2RBsPwpegpvAAAAAElFTkSuQmCC');
    }
}
.orange {
    color: #F28500;
}
.updateButton, .cancelButton {
    width: 100%;
    padding: 0;
    height: 44px;
    line-height: 44px;
    box-sizing: border-box;
    font-size: 14px;
}
.updateButton {
    background: white;
    border:solid 1px #BBBBBB;
}
.cancelButton {
    background: #B3B3B3;
    border: none;
}
</style>
